import * as React from "react";
import PropTypes from 'prop-types';

const SvgHeartFillDark = props => {
  if (props.id !== "_svgheartfilldark") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><path fill="#727272" fillRule="evenodd" d="M21.217 5C18.179 5 16 8.08 16 8.08S13.954 5 10.783 5c-1.593 0-3.176.692-4.334 1.851-1.414 1.414-2.42 3.32-2.448 5.386-.028 2.063.925 4.01 2.295 5.464l8.24 8.46c.415.44.892.84 1.464.84s1.184-.4 1.599-.843l8.243-8.458c1.37-1.455 2.186-3.4 2.157-5.463-.027-2.067-.896-3.974-2.311-5.388C24.53 5.691 22.81 5 21.217 5" /></svg>;
};

SvgHeartFillDark.displayName = "_svgheartfilldark";
SvgHeartFillDark.propTypes = {
  id: PropTypes.string
};
SvgHeartFillDark.defaultProps = {
  id: ''
};
export default SvgHeartFillDark;